﻿define("registerValidation", ["jquery", "bootstrap", "uiNotification"],
    (function ($, bs, uiNotification) {
        var registerValidation = {
            init: function () {      
                var self = this;
                uiNotification.init();
                uiNotification.initTooltip();
                $("input[data-val-required]").css("border-left", "2px solid red");

                if ($("#hdnReCaptchControlState").length > 0) {
                    if ($("#hdnReCaptchControlState").val().toLowerCase() === "false") {
                        $("#register").attr("disabled", true);
                    }
                }

                self.validateMerchantNumber($(".txtMerchantNumber"));
                self.validatePrincipalInfo($(".txtPrincipalInfo"));
                self.validateUsername($(".txtUsername"));
                self.validatePassword($(".txtPassword"));
                self.validateConfirmedPassword($(".txtConfirmPassword"));
                self.validateNameField($(".txtFirstname"));
                self.validateNameField($(".txtLastname"));


                $(".txtMerchantNumber,.txtPrincipalInfo,.txtUsername,.txtFirstname,.txtLastname, .txtPassword, .txtConfirmPassword").on("input", function () {
                    if ($(this).hasClass("txtMerchantNumber")) {
                        self.validateMerchantNumber(this);
                    }
                    else if ($(this).hasClass("txtPrincipalInfo")) {
                        self.validatePrincipalInfo(this);
                    }
                    else if ($(this).hasClass("txtUsername")) {
                        self.validateUsername(this);
                    }
                    else if ($(this).hasClass("txtPassword")) {
                        self.validatePassword(this);
                    }
                    else if ($(this).hasClass("txtConfirmPassword")) {
                        self.validateConfirmedPassword(this);
                    }
                    else if ($(this).hasClass("txtFirstname") || $(this).hasClass("txtLastname")) {
                        if (self.validateRequiredField(this)) {
                            self.changeToGreenBorder(this);
                        } else {
                            self.changeToRedBorder(this);
                        }
                    }

                });
            },

            validateRequiredField: function(e) {
                if ($(e).val() == "") {
                    return false;
                }
                return true;
            },
            validateNameField: function (e) {
                var self = this;
                if (self.validateRequiredField(e)) {
                    self.changeToGreenBorder(e);
                } else {
                    self.changeToRedBorder(e);
                }
            },

            validateMerchantNumber: function(e) {
                if ($(e).length) {
                    var self = this;
                    if (self.validateRequiredField(e)) {
                        if ($(e).val().length <= 16 && $(e).val().length >= 10) {
                            var filter = /^[0-9a-zA-Z]+$/;
                            if (filter.test($(e).val())) {
                                self.changeToGreenBorder(e);
                                return;
                            } else {
                                self.changeToRedBorder(e);
                                return;
                            }
                        } else {
                            self.changeToRedBorder(e);
                            return;
                        }
                    }
                    self.changeToRedBorder(e);
                }
            },

            validateUsername: function(e) {
                if ($(e).length) {
                    var self = this;
                    if (self.validateRequiredField(e)) {
                        var filter = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (filter.test($(e).val())) {
                            self.changeToGreenBorder(e);
                            return;
                        } else {
                            self.changeToRedBorder(e);
                            return;
                        }
                    }
                    self.changeToRedBorder(e);
                }
            },

            validatePassword: function(e) {
                if ($(e).length) {
                    var self = this;
                    if (self.validateRequiredField(e)) {
                        var filter = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*#?&]).{8,40}$/;
                        // var filter = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (filter.test($(e).val())) {
                            self.changeToGreenBorder(e);
                            return;
                        } else {
                            self.changeToRedBorder(e);
                            return;
                        }
                    }
                    self.changeToRedBorder(e);
                }
            },


            validateConfirmedPassword: function(e) {
                if ($(e).length) {
                    var self = this;
                    if (self.validateRequiredField(e)) {
                        var password = $(".txtPassword").val();
                        if ($(e).val() == password) {
                            self.changeToGreenBorder(e);
                            return;
                        }
                    }
                    self.changeToRedBorder(e);
                }
            },

            validatePrincipalInfo: function(e) {
                if ($(e).length) {
                    var self = this;
                    if (self.validateRequiredField(e)) {
                        if ($(e).val().length == 9) {
                            self.changeToGreenBorder(e);
                            return;
                        }
                    }
                    self.changeToRedBorder(e);
                }
            },

            changeToGreenBorder: function(e) {
                $(e).css("border-left", "2px solid green");
            },

            changeToRedBorder: function (e) {
                $(e).css("border-left", "2px solid red");
            }
        };
        return registerValidation;
    })
)